import {
  AccountInfo,
  AccountMFA,
  AccountPreferences,
  EmailConfirm,
  EmailEnroll,
  RecoveryCodes,
  TotpEnroll,
} from '@/types'
import { useFetchWithInterceptor } from '@/use'
import { toRaw } from 'vue'

export const getAccountInfo = async (): Promise<AccountInfo> => {
  const { response, request } = useFetchWithInterceptor<AccountInfo>(`${import.meta.env.VITE_API_URL}/account/info`)
  await request()
  if (response.value) {
    return toRaw(response.value)
  } else {
    throw new Error('Response is undefined')
  }
}

export const getAccountPreferences = async (): Promise<AccountPreferences> => {
  const { response, request } = useFetchWithInterceptor<AccountPreferences>(
    `${import.meta.env.VITE_API_URL}/account/preferences`,
  )
  await request()
  if (response.value) {
    return toRaw(response.value)
  } else {
    throw new Error('Response is undefined')
  }
}

export const updateAccountPreferences = async (payload: AccountPreferences): Promise<AccountPreferences> => {
  const { response, request } = useFetchWithInterceptor<AccountPreferences>(
    `${import.meta.env.VITE_API_URL}/account/preferences`,
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    },
  )
  await request()
  if (response.value) {
    return toRaw(response.value)
  } else {
    throw new Error('Response is undefined')
  }
}

export const getUserMFA = async (): Promise<AccountMFA> => {
  const { response, request } = useFetchWithInterceptor<AccountMFA>(`${import.meta.env.VITE_API_URL}/account/mfa`)
  await request()
  if (response.value) {
    return new AccountMFA(toRaw(response.value))
  } else {
    throw new Error('Response is undefined')
  }
}

export const emailEnroll = async (): Promise<EmailEnroll> => {
  const { response, request } = useFetchWithInterceptor<EmailEnroll>(
    `${import.meta.env.VITE_API_URL}/account/mfa/email-enroll`,
    {
      method: 'POST',
      body: JSON.stringify({}),
    },
  )
  await request()
  if (response.value) {
    return new EmailEnroll(toRaw(response.value))
  } else {
    throw new Error('Response is undefined')
  }
}

export const deleteAutenticator = async (id: string) => {
  const { request } = useFetchWithInterceptor(`${import.meta.env.VITE_API_URL}/account/mfa/authenticators/${id}`, {
    method: 'DELETE',
  })
  await request()
}

export const totpEnroll = async (): Promise<TotpEnroll> => {
  const { response, request } = useFetchWithInterceptor<TotpEnroll>(
    `${import.meta.env.VITE_API_URL}/account/mfa/totp-enroll`,
    {
      method: 'POST',
      body: JSON.stringify({}),
    },
  )
  await request()
  if (response.value) {
    return new TotpEnroll(toRaw(response.value))
  } else {
    throw new Error('Response is undefined')
  }
}

export const totpConfirm = async (model: EmailConfirm): Promise<RecoveryCodes> => {
  const { response, request } = useFetchWithInterceptor<RecoveryCodes>(
    `${import.meta.env.VITE_API_URL}/account/mfa/totp-confirm`,
    {
      method: 'POST',
      body: JSON.stringify(model),
    },
  )
  await request()
  if (response.value) {
    return new RecoveryCodes(toRaw(response.value))
  } else {
    throw new Error('Response is undefined')
  }
}

export const enableMFA = async () => {
  const { request } = useFetchWithInterceptor(`${import.meta.env.VITE_API_URL}/account/mfa/enable`, {
    method: 'POST',
    body: JSON.stringify({}),
  })
  await request()
}

export const disableMFA = async () => {
  const { request } = useFetchWithInterceptor(`${import.meta.env.VITE_API_URL}/account/mfa/disable`, {
    method: 'POST',
  })
  await request()
}

export const getRecoveryCodes = async (): Promise<RecoveryCodes> => {
  const { response, request } = useFetchWithInterceptor<RecoveryCodes>(
    `${import.meta.env.VITE_API_URL}/account/mfa/recovery-codes`,
    {
      method: 'GET',
    },
  )
  await request()
  if (response.value) {
    return new RecoveryCodes(toRaw(response.value))
  } else {
    throw new Error('Response is undefined')
  }
}

export const regenerateRecoveryCodes = async () => {
  const { request } = useFetchWithInterceptor(`${import.meta.env.VITE_API_URL}/account/mfa/recovery-codes/regenerate`, {
    method: 'POST',
  })
  await request()
}
